import BaseModal from './baseModal';

export default class Peoples extends BaseModal {
  constructor() {
    super('person-modal-bg', 'person-modal');
    if (this.modal) {
      this.init();
    }
  }

  init() {
    super.init();

    Array.from(document.getElementsByClassName('person-item')).forEach((p) => {
      p.addEventListener('click', () => {
        const title = document.querySelector('#' + p.id + ' .person-title').innerHTML;
        const jobtitle = document.querySelector('#' + p.id + ' .person-jobtitle').innerHTML;
        const image = document.querySelector('#' + p.id + ' .person-image').dataset.src;

        let email = null;
        if (document.querySelector('#' + p.id + ' .person-email')) {
          email = document.querySelector('#' + p.id + ' .person-email').attributes.href.value;
        }

        let linkedin = null;
        if (document.querySelector('#' + p.id + ' .person-linkedin')) {
          linkedin = document.querySelector('#' + p.id + ' .person-linkedin').attributes.href.value;
        }

        const description = document.querySelector('#' + p.id + ' .person-description').innerHTML;

        let value = null;
        if (document.querySelector('#' + p.id + ' .person-value')) {
          value = document.querySelector('#' + p.id + ' .person-value').innerHTML;
        }

        this.modal.querySelectorAll('.person-title').forEach((el) => (el.innerHTML = title));
        this.modal.querySelectorAll('.person-jobtitle').forEach((el) => (el.innerHTML = jobtitle));
        this.modal.querySelector('.description').innerHTML = description;

        const contactContainer = this.modal.querySelector('.contact-container');

        if (email) {
          if (contactContainer) {
            this.modal.querySelector('.contact-container').classList.remove('hidden');
          }
          this.modal.querySelector('.person-email').classList.remove('hidden');
          this.modal.querySelector('.person-email').href = email;
        } else {
          this.modal.querySelector('.person-email').classList.add('hidden');
        }

        if (linkedin) {
          if (contactContainer) {
            this.modal.querySelector('.contact-container').classList.remove('hidden');
          }
          this.modal.querySelector('.person-linkedin').classList.remove('hidden');
          this.modal.querySelector('.person-linkedin').href = linkedin;
        } else {
          this.modal.querySelector('.person-linkedin').classList.add('hidden');
        }

        if (!email && !linkedin) {
          if (contactContainer) {
            this.modal.querySelector('.contact-container').classList.add('hidden');
          }
        }

        if (value) {
          this.modal.querySelector('.value').classList.remove('hidden');
          this.modal.querySelector('.value').innerHTML = value;
        } else if (this.modal.querySelector('.value')) {
          this.modal.querySelector('.value').classList.add('hidden');
        }

        this.modal.querySelector('.person-image').src = image;

        this.show();
      });
    });

    // Trigger Modal onload base on hash
    if (location.hash) {
      const hashElement = document.querySelector(location.hash);

      if (hashElement?.classList.contains('person-item')) {
        hashElement.click();
      }
    }
  }
}
